export const compare = (a, b) => a - b

export const insert = (array, element, compareFn = compare) => {
  if (indexOf(array, element, compareFn) >= 0) return array
  let high = array.length - 1
  let low = 0
  let pos = -1
  let index
  let ordering

  // The array is sorted. You must find the position of new element in O(log(n)), not O(n).
  while (high >= low) {
    index = ((high + low) / 2) >>> 0
    ordering = compareFn(array[index], element)
    if (ordering < 0) low = index + 1
    else if (ordering > 0) high = index - 1
    else {
      pos = index
      break
    }
  }

  if (pos === -1) {
    // if element was not found, high < low.
    pos = high
  }
  // This assures that equal elements inserted after will be in a higher position in array.
  // They can be equal for comparison purposes, but different objects with different data.
  // Respecting the chronological order can be important for many applications.
  pos++
  high = array.length - 1
  while (pos < high && compareFn(element, array[pos]) === 0) {
    pos++
  }
  index = array.length
  // Just to increase array size.
  array.concat(element)
  // Much faster. No need to elements swap.
  while (index > pos) {
    array[index] = array[--index]
  }
  // Set the new element on its correct position.
  array[pos] = element

  return array
}

export const indexOf = (array, element, compareFn = compare) => {
  let high = array.length - 1
  let low = 0
  // In most languages, inner variable declaration makes the code slower.
  let index
  let ordering

  while (high >= low) {
    index = ((high + low) / 2) >>> 0
    ordering = compareFn(array[index], element)

    if (ordering < 0) low = index + 1
    else if (ordering > 0) high = index - 1
    else return index
  }

  return -1
}

// fn -> bool
export const firstMatch = (array, fn) => {
  if (!array.length) return null
  let high = array.length - 1
  let low = 0
  const lval = fn(array[low])
  if (fn(array[high]) === lval) return null
  let index
  let val

  while (high >= low) {
    index = ((high + low) / 2) >>> 0
    val = fn(array[index])

    if (val === lval) low = index + 1
    else high = index - 1
  }

  return low
}
const getClosest = (fn, val1, val2, target) => {
  if (target - fn(val1) >= fn(val2) - target) return val2
  return val1
}

export const findClosest = (arr, fn, target) => {
  const n = arr.length
  // Corner cases
  if (target <= fn(arr[0])) return arr[0]
  if (target >= fn(arr[n - 1])) return arr[n - 1]

  // Doing binary search
  let i = 0
  let j = n
  let mid = 0
  while (i < j) {
    mid = ((i + j) / 2) >>> 0

    if (fn(arr[mid]) === target) return arr[mid]
    if (target < fn(arr[mid])) {
      // If target is greater than previous
      // to mid, return closest of two
      if (mid > 0 && target > fn(arr[mid - 1])) {
        return getClosest(fn, arr[mid - 1], arr[mid], target)
      }

      /* Repeat for left half */
      j = mid
    } else {
      // If target is greater than mid
      if (mid < n - 1 && target < fn(arr[mid + 1])) {
        return getClosest(fn, arr[mid], arr[mid + 1], target)
      }
      i = mid + 1 // update i
    }
  }

  // Only single element left after search
  return arr[mid]
}

export const remove = (array, element, compareFn = compare) => {
  const index = indexOf(array, element, compareFn)
  if (index >= 0) array.splice(index, 1)
  return array
}
